import React from 'react'
import Aboutpage from '../Components/Aboutpage/Aboutpage'
import Counter from '../Components/Cards/Countercard/Counter'

function About() {
  return (
    <div>
      <Aboutpage/>
      <Counter/>
    </div>
  )
}

export default About
